import foodServiceImage1 from 'assets/product/product-upload-wizard/food-service/image1.jpg';
import foodServiceImage2 from 'assets/product/product-upload-wizard/food-service/image2.jpg';
import foodServiceImage3 from 'assets/product/product-upload-wizard/food-service/image3.jpg';
import foodServiceImage4 from 'assets/product/product-upload-wizard/food-service/image4.png';
import foodServiceImage5 from 'assets/product/product-upload-wizard/food-service/image5.jpeg';
import foodServiceImage6 from 'assets/product/product-upload-wizard/food-service/image6.png';
import produceCucumberImage from 'assets/product/product-upload-wizard/food-service/produce-cucumber.webp';
import produceEggplantImage from 'assets/product/product-upload-wizard/food-service/produce-eggplant.png';
import produceCabbageCaseImage from 'assets/product/product-upload-wizard/food-service/produce-cabbage-case.png';
import produceCabbageUnitImage from 'assets/product/product-upload-wizard/food-service/produce-cabbage-unit.png';
import deliApplegateTurkeyImage from 'assets/product/product-upload-wizard/food-service/deli-applegate-turkey.jpg';
import bulkBrickCheeseImage from 'assets/product/product-upload-wizard/food-service/bulk-brick-cheese.jpg';

import merchandisedInTrayImage1 from 'assets/product/product-upload-wizard/merchandise-in-tray/image1.jpeg';
import merchandisedInTrayImage2 from 'assets/product/product-upload-wizard/merchandise-in-tray/image2.jpeg';
import merchandisedInTrayImage3 from 'assets/product/product-upload-wizard/merchandise-in-tray/image3.jpeg';
import merchandisedInTrayImage4 from 'assets/product/product-upload-wizard/merchandise-in-tray/image4.jpeg';
import merchandisedInTrayImage5 from 'assets/product/product-upload-wizard/merchandise-in-tray/image5.jpeg';
import merchandisedInTrayImage6 from 'assets/product/product-upload-wizard/merchandise-in-tray/image6.jpeg';
import merchandisedInTrayImage7 from 'assets/product/product-upload-wizard/merchandise-in-tray/image7.jpeg';
import merchandisedInTrayImage8 from 'assets/product/product-upload-wizard/merchandise-in-tray/image8.jpeg';

import innnerpackGroup1_1 from 'assets/product/product-upload-wizard/sellable-innerpack/innerpack/innerpack-group1-1.jpeg';
import innnerpackGroup1_2 from 'assets/product/product-upload-wizard/sellable-innerpack/innerpack/innerpack-group1-2.jpeg';
import innnerpackGroup2_1 from 'assets/product/product-upload-wizard/sellable-innerpack/innerpack/innerpack-group2-1.jpeg';
import innnerpackGroup3_1 from 'assets/product/product-upload-wizard/sellable-innerpack/innerpack/innerpack-group3-1.jpeg';
import innnerpackGroup3_2 from 'assets/product/product-upload-wizard/sellable-innerpack/innerpack/innerpack-group3-2.jpeg';
import innnerpackGroup4_1 from 'assets/product/product-upload-wizard/sellable-innerpack/innerpack/innerpack-group4-1.jpeg';
import innnerpackGroup4_2 from 'assets/product/product-upload-wizard/sellable-innerpack/innerpack/innerpack-group4-2.jpeg';

import unitGroup1 from 'assets/product/product-upload-wizard/sellable-innerpack/unit/unit-group1.jpeg';
import unitGroup2 from 'assets/product/product-upload-wizard/sellable-innerpack/unit/unit-group2.jpeg';
import unitGroup3 from 'assets/product/product-upload-wizard/sellable-innerpack/unit/unit-group3.jpeg';
import unitGroup4 from 'assets/product/product-upload-wizard/sellable-innerpack/unit/unit-group4.jpeg';

import storeDisplayImage1 from 'assets/product/product-upload-wizard/store-display/image1.png';
import storeDisplayImage2 from 'assets/product/product-upload-wizard/store-display/image2.png';
import storeDisplayImage3 from 'assets/product/product-upload-wizard/store-display/image3.png';
import storeDisplayImage4 from 'assets/product/product-upload-wizard/store-display/image4.png';
import storeDisplayImage5 from 'assets/product/product-upload-wizard/store-display/image5.png';
import storeDisplayImage6 from 'assets/product/product-upload-wizard/store-display/image6.png';
import storeDisplayImage7 from 'assets/product/product-upload-wizard/store-display/image7.jpeg';
import storeDisplayImage8 from 'assets/product/product-upload-wizard/store-display/image8.jpeg';

import perishableImage1 from 'assets/product/product-upload-wizard/perishable/image1.jpeg';
import perishableImage2 from 'assets/product/product-upload-wizard/perishable/image2.jpeg';
import perishableImage3 from 'assets/product/product-upload-wizard/perishable/image3.jpeg';
import perishableImage4 from 'assets/product/product-upload-wizard/perishable/image4.jpeg';
import perishableImage5 from 'assets/product/product-upload-wizard/perishable/image5.jpeg';
import perishableImage6 from 'assets/product/product-upload-wizard/perishable/image6.jpeg';
import perishableImage7 from 'assets/product/product-upload-wizard/perishable/image7.jpeg';

import multipackImage1 from 'assets/product/product-upload-wizard/multipack/image1.jpeg';
import multipackImage2 from 'assets/product/product-upload-wizard/multipack/image2.jpeg';
import multipackImage3 from 'assets/product/product-upload-wizard/multipack/image3.jpeg';

/**
 * Step Types
 */
export const STEP_TYPES = {
  INTRO: 'intro',
  YES_NO: 'yesNo',
  FOOD_SERVICE: 'foodService',
  ADULT_BEVERAGE: 'adultBeverage',
  PRODUCT_GRID_QUESTION: 'productGridQuestion',
  INPUT: 'input',
  RECOMMENDATION: 'recommendation',
  RECOMMENDATION_MORE_THAN_15_PRODUCTS: 'recommendationMoreThan15Products',
  RECOMMENDATION_MORE_LESS_15_PRODUCTS: 'recommendationLessThan15Products',
  CONTACT_SALES: 'contactSales',
  SUCCESS: 'success',
};

/**
 * Shared Text Constants
 * Avoids duplication across steps
 */
export const WIZARD_TEXT = {
  // Common question title
  QUESTION_TITLE:
    "Let's step through some basic questions so we can recommend the best submission method",

  // Shipping address placeholder (show in red until actual address provided)
  SHIPPING_ADDRESS_PLACEHOLDER: '[ADDRESS - TO BE PROVIDED]',

  // Contact sales message
  CONTACT_SALES_MESSAGE:
    'Based on your answers, we recommend speaking with a Member Success specialist. Please contact us for assistance with your specific product requirements.',
};

/**
 * Help content shown beside each guided question
 */
const foodServiceDefinitions = [
  {
    label: 'Foodservice',
    description: 'Larger volume items, case is the lowest sellable level, its contents are not intended for individual resale. Usually intended for restaurants, institutions, or commercial kitchens.',
  },
  {
    label: 'Bulk items',
    description: 'Larger volume items, usually in a case, contents have a unique barcode and are intended to be broken down and sold by weight or quantity. Can be Variable Weight / Catch Weight. Usually intended for retail stores.',
  },
  {
    label: 'Variable Weight / Catch Weight',
    description: 'Items that cannot be standardized to a single fixed weight. Instead, they are priced and tracked by their actual, measured weight or by number of items. Examples: Meat, fish, cheese, or fresh produce.',
  },
];

export const HELP_CONTENT = {
  foodService: {
    title: 'Foodservice / Bulk Items',
    definitions: foodServiceDefinitions,
    images: [
      foodServiceImage1,
      foodServiceImage2,
      foodServiceImage3,
      foodServiceImage4,
      foodServiceImage5,
      foodServiceImage6,
      produceCucumberImage,
      produceEggplantImage,
      produceCabbageUnitImage,
      produceCabbageCaseImage,
      deliApplegateTurkeyImage,
      bulkBrickCheeseImage,
    ],
  },
  alcoholic: {
    title: 'Alcoholic Beverages',
    description:
      'Products containing alcohol including beer, wine, spirits, and ready-to-drink cocktails. These products have special handling requirements.',
  },
  retailInnerPack: {
    title: 'Sellable Innerpack',
    description:
      'A “sellable innerpack” is an intermediate package containing multiple units. It must have its own retail-scannable barcode such as a UPC-12 or EAN-13. This barcode cannot be the same barcode as the items it contains. Innerpacks without a UPC-12 or EAN-13 are not considered “Sellable Innerpacks.”',
    groupedImages: [
      {
        label: 'Olyra Breakfast Biscuits',
        innerpack: [innnerpackGroup1_1, innnerpackGroup1_2],
        unit: unitGroup1,
      },
      {
        label: 'Dr Pepper & Cream Soda',
        innerpack: [innnerpackGroup2_1],
        unit: unitGroup2,
      },
      {
        label: 'MadeGood Mornings Oat Bars',
        innerpack: [innnerpackGroup3_1, innnerpackGroup3_2],
        unit: unitGroup3,
      },
      {
        label: 'Cerebelly Organic Puree',
        innerpack: [innnerpackGroup4_1, innnerpackGroup4_2],
        unit: unitGroup4,
      },
    ],
  },
  storeDisplay: {
    title: 'Store Display / Shipper',
    description:
      'A store display, also called a “shipper,” is a self-contained display used to present one or more products outside of the store’s standard sales shelving.',
    images: [
      storeDisplayImage1,
      storeDisplayImage2,
      storeDisplayImage3,
      storeDisplayImage4,
      storeDisplayImage5,
      storeDisplayImage6,
      storeDisplayImage7,
      storeDisplayImage8,
    ],
  },
  merchandisedInTray: {
    title: 'Merchandised in Tray',
    description:
      'Refers to products merchandised in packaging, typically a tray, that holds and organizes the items and is placed directly on a retailer’s shelf. This shelf-ready packaging may be sellable on its own if it has a retail-scannable barcode that is different from the items it contains.',
    images: [
      merchandisedInTrayImage1,
      merchandisedInTrayImage2,
      merchandisedInTrayImage3,
      merchandisedInTrayImage4,
      merchandisedInTrayImage5,
      merchandisedInTrayImage6,
      merchandisedInTrayImage7,
      merchandisedInTrayImage8,
    ],
  },
  perishable: {
    title: 'Perishable',
    description:
      'Perishable items have a limited shelf life, are not shelf stable, and may spoil or significantly lose quality within a relatively short period. This does not include products that are shelf stable until opened. Examples: Fresh produce, meat, seafood, dairy products, refrigerated drinks, and prepared foods.',
    images: [
      perishableImage1,
      perishableImage2,
      perishableImage3,
      perishableImage4,
      perishableImage5,
      perishableImage6,
      perishableImage7,
    ],
  },
  multipack: {
    title: 'Multipack',
    description:
      'Often referred to as a variety pack, it is a single package that holds two or more identical or similar items sold together as one unit with a single retail-scannable barcode.',
    images: [multipackImage1, multipackImage2, multipackImage3],
  },
};

/**
 * Pricing Configuration
 * Note: Pricing per capture is going away (March 2027)
 * Some members may have $0 capture fees based on new membership model
 */
export const PRICING_CONFIG = {
  fullCapture: 199,
  unitCapture: 99,
  // Future: will be $0 for new membership model
};

export const STEPS = {
  // ============================================
  // INTRO
  // ============================================
  intro: {
    type: STEP_TYPES.INTRO,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      description:
        "If you already know how you are submitting the new item's data for capture, you can bypass this wizard by clicking.",
      bypassText: 'Submit Products',
    },
    next: 'productCount',
  },

  // ============================================
  // QUESTIONS
  // ============================================
  productCount: {
    type: STEP_TYPES.INPUT,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question:
        'Approximately how many products do you plan to send in for capture?',
      placeholder: 'Enter number',
      helpText: '<=15 = recommend data grid | >15 = recommend template',
    },
    field: 'productCount',
    inputType: 'number',
    validation: {
      required: true,
      min: 1,
    },
    next: (answers) => {
      if (answers.productCount > 15) return 'recommendTemplate';
      return 'foodService';
    },
  },

  productGridQuestion: {
    type: STEP_TYPES.PRODUCT_GRID_QUESTION,
    content: {
      title: null,
      description:
        'Will you be submitting new product information via online data grid, or product load form template?',
    },
  },
  foodService: {
    type: STEP_TYPES.FOOD_SERVICE,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question: 'Are any of your products Foodservice or bulk items?',
    },
    variableWeightQuestion:
      'Is the item a Variable Weight or Catch Weight item?',
    field: 'foodServiceBulkItems',
    help: HELP_CONTENT.foodService,

    next: 'alcoholic',
  },

  alcoholic: {
    type: STEP_TYPES.ADULT_BEVERAGE,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question: 'Are any of your products Adult Beverages?',
    },
    field: 'alcoholicBeverages',
    help: null,
    next: 'retailInnerPack',
  },

  retailInnerPack: {
    type: STEP_TYPES.YES_NO,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question:
        'Are the products you are submitting for capture packaged in a retail sellable inner pack?',
    },
    field: 'sellableInnerPack',
    help: HELP_CONTENT.retailInnerPack,
    next: 'storeDisplay',
  },

  storeDisplay: {
    type: STEP_TYPES.YES_NO,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question: 'Are any of your products Store Displays or Shippers?',
    },
    field: 'displayShippers',
    help: HELP_CONTENT.storeDisplay,
    next: 'merchandisedInTray',
  },

  merchandisedInTray: {
    type: STEP_TYPES.YES_NO,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question:
        'Are any of your sellable unit items contained in a shelf display box or tray?',
    },
    field: 'shelfDisplayBoxTray',
    help: HELP_CONTENT.merchandisedInTray,
    next: 'multipack',
  },

  multipack: {
    type: STEP_TYPES.YES_NO,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question: 'Are any of your products Multipack?',
    },
    field: 'multipacks',
    help: HELP_CONTENT.multipack,
    next: 'perishable',
  },

  perishable: {
    type: STEP_TYPES.YES_NO,
    content: {
      title: WIZARD_TEXT.QUESTION_TITLE,
      question: 'Lastly – Are your items Perishable?',
    },
    field: 'perishable',
    help: HELP_CONTENT.perishable,
    next: (answers) => {
      if (answers.productCount > 15) {
        return 'recommendTemplate';
      }

      return 'recommendGrid';
    },
  },

  // ============================================
  // RECOMMENDATIONS
  // ============================================
  recommendTemplate: {
    type: STEP_TYPES.RECOMMENDATION_MORE_THAN_15_PRODUCTS,
    content: {
      title: 'Submitting more than 15 products',
      description:
        'Based on your answers, we recommend using the product template.',
    },
    recommendationType: 'template',
    next: 'null',
  },

  recommendGrid: {
    type: STEP_TYPES.RECOMMENDATION_MORE_LESS_15_PRODUCTS,
    content: {
      title: 'Submitting less than 15 products',
      description:
        'Based on your answers, we recommend using the Product Submission Grid in the SPINS IX-ONE Platform.',
    },
    recommendationType: 'grid',
    next: 'contactSales',
  },

  // ============================================
  // CONTACT SALES (Terminal)
  // ============================================
  contactSales: {
    type: 'contactSales',
    content: {
      title: 'Contact Member Success',
      description:
        'Based on your answers, we recommend speaking with a Member Success specialist. Please <insert direction>',
    },
    next: null,
  },

  // ============================================
  // SUCCESS (Terminal)
  // ============================================
  success: {
    type: STEP_TYPES.SUCCESS,
    content: {
      title: 'Submission Successful',
      description:
        'Your submission has been successfully processed, and our professional capture studio is now on the lookout for your products to arrive.',
      shippingInfo: {
        fullCapture: `Please ship full cases to: ${WIZARD_TEXT.SHIPPING_ADDRESS_PLACEHOLDER} as quickly as possible.`,
        unitCapture: `Please ship at least three live samples to: ${WIZARD_TEXT.SHIPPING_ADDRESS_PLACEHOLDER} as quickly as possible.`,
        mixed: `Please ship full cases and at least three live samples to: ${WIZARD_TEXT.SHIPPING_ADDRESS_PLACEHOLDER} as quickly as possible.`,
      },
      address: WIZARD_TEXT.SHIPPING_ADDRESS_PLACEHOLDER,
    },
    next: null, // Terminal step
  },
};

/**
 * Get step by key
 */
export const getStep = (stepKey) => STEPS[stepKey] || null;

/**
 * Get all step keys
 */
export const getStepKeys = () => Object.keys(STEPS);

/**
 * Check if step is terminal (no next step)
 */
export const isTerminalStep = (stepKey) => {
  const step = STEPS[stepKey];
  return step?.next === null;
};

export default STEPS;
